import type { LatLng } from '@/types/structs'

/* Dart LatLng has STRUCTURAL equality (operator== on lat+lng). JS objects
 * compare by reference — every didUpdateWidget branch that asks "did the
 * location change?" must go through this, or a same-coords tick would be
 * treated as a change (Dart would not). */
export function latLngEquals(
  a: LatLng | null | undefined,
  b: LatLng | null | undefined,
): boolean {
  if (a == null || b == null) return a == null && b == null
  return a.lat === b.lat && a.lng === b.lng
}

/** `"${lat},${lng}"` — the getDirections origin/destination format. */
export function serializeLatLng(p: LatLng): string {
  return `${p.lat},${p.lng}`
}
